export default "__VITE_ASSET__BG5Rhrtv__ 36w, __VITE_ASSET__DZQMdxlK__ 72w, __VITE_ASSET__6hkI5Ctp__ 108w";